module.exports = __webpack_public_path__ + "static/img/2.796c437.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/1/eng/2.png
// module id = kx8n
// module chunks = 0